module.exports = __webpack_public_path__ + "static/epoxy-5920e80502203f90a674fc3f52d362a7.jpg";